'use strict';

var CompetitorFaresCombinedFilterDirective = function CompetitorFaresCombinedFilterDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'CompetitorFaresCombinedFilterController',
    template: require('../templates/competitor-fares-combined-filter.html'),
    scope: {
      updateCallBack: '=',
      filter: '=',
      filterDisplay: '=?'
    },
    link: function link(scope, element) {
      element.on('mousedown, click', function (e) {
        e.stopImmediatePropagation();
      });
      if (scope.filterDisplay) {
        scope.$watch('filter.display', scope.correctMatchedValues);
      }
    }
  };
};
module.exports = CompetitorFaresCombinedFilterDirective;